/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AlleRouteImport } from './routes/alle'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrognoseIndexRouteImport } from './routes/prognose/index'
import { Route as InconsistentOrdersIndexRouteImport } from './routes/inconsistent-orders/index'
import { Route as EkStuecklisteIndexRouteImport } from './routes/ek-stueckliste/index'
import { Route as AbzugBremenIndexRouteImport } from './routes/abzug-bremen/index'
import { Route as VorschlagBestellvorschlagIdRouteImport } from './routes/vorschlag/$bestellvorschlagId'
import { Route as TopsellerKundennummerRouteImport } from './routes/topseller/$kundennummer'
import { Route as PrognoseArticleNumberRouteImport } from './routes/prognose/$articleNumber'
import { Route as LagerauswertungWickerRouteImport } from './routes/lagerauswertung/wicker'
import { Route as CustomerKundennummerRouteImport } from './routes/customer/$kundennummer'
import { Route as LagerauswertungAlleDateRouteImport } from './routes/lagerauswertung/alle.$date'
import { Route as LagerauswertungWarehouseIdDateRouteImport } from './routes/lagerauswertung/$warehouseId.$date'
import { Route as LagerauswertungCompareDateDate2RouteImport } from './routes/lagerauswertung/compare.$date.$date2'

const AlleRoute = AlleRouteImport.update({
  id: '/alle',
  path: '/alle',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrognoseIndexRoute = PrognoseIndexRouteImport.update({
  id: '/prognose/',
  path: '/prognose/',
  getParentRoute: () => rootRouteImport,
} as any)
const InconsistentOrdersIndexRoute = InconsistentOrdersIndexRouteImport.update({
  id: '/inconsistent-orders/',
  path: '/inconsistent-orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const EkStuecklisteIndexRoute = EkStuecklisteIndexRouteImport.update({
  id: '/ek-stueckliste/',
  path: '/ek-stueckliste/',
  getParentRoute: () => rootRouteImport,
} as any)
const AbzugBremenIndexRoute = AbzugBremenIndexRouteImport.update({
  id: '/abzug-bremen/',
  path: '/abzug-bremen/',
  getParentRoute: () => rootRouteImport,
} as any)
const VorschlagBestellvorschlagIdRoute =
  VorschlagBestellvorschlagIdRouteImport.update({
    id: '/vorschlag/$bestellvorschlagId',
    path: '/vorschlag/$bestellvorschlagId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TopsellerKundennummerRoute = TopsellerKundennummerRouteImport.update({
  id: '/topseller/$kundennummer',
  path: '/topseller/$kundennummer',
  getParentRoute: () => rootRouteImport,
} as any)
const PrognoseArticleNumberRoute = PrognoseArticleNumberRouteImport.update({
  id: '/prognose/$articleNumber',
  path: '/prognose/$articleNumber',
  getParentRoute: () => rootRouteImport,
} as any)
const LagerauswertungWickerRoute = LagerauswertungWickerRouteImport.update({
  id: '/lagerauswertung/wicker',
  path: '/lagerauswertung/wicker',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerKundennummerRoute = CustomerKundennummerRouteImport.update({
  id: '/customer/$kundennummer',
  path: '/customer/$kundennummer',
  getParentRoute: () => rootRouteImport,
} as any)
const LagerauswertungAlleDateRoute = LagerauswertungAlleDateRouteImport.update({
  id: '/lagerauswertung/alle/$date',
  path: '/lagerauswertung/alle/$date',
  getParentRoute: () => rootRouteImport,
} as any)
const LagerauswertungWarehouseIdDateRoute =
  LagerauswertungWarehouseIdDateRouteImport.update({
    id: '/lagerauswertung/$warehouseId/$date',
    path: '/lagerauswertung/$warehouseId/$date',
    getParentRoute: () => rootRouteImport,
  } as any)
const LagerauswertungCompareDateDate2Route =
  LagerauswertungCompareDateDate2RouteImport.update({
    id: '/lagerauswertung/compare/$date/$date2',
    path: '/lagerauswertung/compare/$date/$date2',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alle': typeof AlleRoute
  '/customer/$kundennummer': typeof CustomerKundennummerRoute
  '/lagerauswertung/wicker': typeof LagerauswertungWickerRoute
  '/prognose/$articleNumber': typeof PrognoseArticleNumberRoute
  '/topseller/$kundennummer': typeof TopsellerKundennummerRoute
  '/vorschlag/$bestellvorschlagId': typeof VorschlagBestellvorschlagIdRoute
  '/abzug-bremen': typeof AbzugBremenIndexRoute
  '/ek-stueckliste': typeof EkStuecklisteIndexRoute
  '/inconsistent-orders': typeof InconsistentOrdersIndexRoute
  '/prognose': typeof PrognoseIndexRoute
  '/lagerauswertung/$warehouseId/$date': typeof LagerauswertungWarehouseIdDateRoute
  '/lagerauswertung/alle/$date': typeof LagerauswertungAlleDateRoute
  '/lagerauswertung/compare/$date/$date2': typeof LagerauswertungCompareDateDate2Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alle': typeof AlleRoute
  '/customer/$kundennummer': typeof CustomerKundennummerRoute
  '/lagerauswertung/wicker': typeof LagerauswertungWickerRoute
  '/prognose/$articleNumber': typeof PrognoseArticleNumberRoute
  '/topseller/$kundennummer': typeof TopsellerKundennummerRoute
  '/vorschlag/$bestellvorschlagId': typeof VorschlagBestellvorschlagIdRoute
  '/abzug-bremen': typeof AbzugBremenIndexRoute
  '/ek-stueckliste': typeof EkStuecklisteIndexRoute
  '/inconsistent-orders': typeof InconsistentOrdersIndexRoute
  '/prognose': typeof PrognoseIndexRoute
  '/lagerauswertung/$warehouseId/$date': typeof LagerauswertungWarehouseIdDateRoute
  '/lagerauswertung/alle/$date': typeof LagerauswertungAlleDateRoute
  '/lagerauswertung/compare/$date/$date2': typeof LagerauswertungCompareDateDate2Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alle': typeof AlleRoute
  '/customer/$kundennummer': typeof CustomerKundennummerRoute
  '/lagerauswertung/wicker': typeof LagerauswertungWickerRoute
  '/prognose/$articleNumber': typeof PrognoseArticleNumberRoute
  '/topseller/$kundennummer': typeof TopsellerKundennummerRoute
  '/vorschlag/$bestellvorschlagId': typeof VorschlagBestellvorschlagIdRoute
  '/abzug-bremen/': typeof AbzugBremenIndexRoute
  '/ek-stueckliste/': typeof EkStuecklisteIndexRoute
  '/inconsistent-orders/': typeof InconsistentOrdersIndexRoute
  '/prognose/': typeof PrognoseIndexRoute
  '/lagerauswertung/$warehouseId/$date': typeof LagerauswertungWarehouseIdDateRoute
  '/lagerauswertung/alle/$date': typeof LagerauswertungAlleDateRoute
  '/lagerauswertung/compare/$date/$date2': typeof LagerauswertungCompareDateDate2Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alle'
    | '/customer/$kundennummer'
    | '/lagerauswertung/wicker'
    | '/prognose/$articleNumber'
    | '/topseller/$kundennummer'
    | '/vorschlag/$bestellvorschlagId'
    | '/abzug-bremen'
    | '/ek-stueckliste'
    | '/inconsistent-orders'
    | '/prognose'
    | '/lagerauswertung/$warehouseId/$date'
    | '/lagerauswertung/alle/$date'
    | '/lagerauswertung/compare/$date/$date2'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alle'
    | '/customer/$kundennummer'
    | '/lagerauswertung/wicker'
    | '/prognose/$articleNumber'
    | '/topseller/$kundennummer'
    | '/vorschlag/$bestellvorschlagId'
    | '/abzug-bremen'
    | '/ek-stueckliste'
    | '/inconsistent-orders'
    | '/prognose'
    | '/lagerauswertung/$warehouseId/$date'
    | '/lagerauswertung/alle/$date'
    | '/lagerauswertung/compare/$date/$date2'
  id:
    | '__root__'
    | '/'
    | '/alle'
    | '/customer/$kundennummer'
    | '/lagerauswertung/wicker'
    | '/prognose/$articleNumber'
    | '/topseller/$kundennummer'
    | '/vorschlag/$bestellvorschlagId'
    | '/abzug-bremen/'
    | '/ek-stueckliste/'
    | '/inconsistent-orders/'
    | '/prognose/'
    | '/lagerauswertung/$warehouseId/$date'
    | '/lagerauswertung/alle/$date'
    | '/lagerauswertung/compare/$date/$date2'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlleRoute: typeof AlleRoute
  CustomerKundennummerRoute: typeof CustomerKundennummerRoute
  LagerauswertungWickerRoute: typeof LagerauswertungWickerRoute
  PrognoseArticleNumberRoute: typeof PrognoseArticleNumberRoute
  TopsellerKundennummerRoute: typeof TopsellerKundennummerRoute
  VorschlagBestellvorschlagIdRoute: typeof VorschlagBestellvorschlagIdRoute
  AbzugBremenIndexRoute: typeof AbzugBremenIndexRoute
  EkStuecklisteIndexRoute: typeof EkStuecklisteIndexRoute
  InconsistentOrdersIndexRoute: typeof InconsistentOrdersIndexRoute
  PrognoseIndexRoute: typeof PrognoseIndexRoute
  LagerauswertungWarehouseIdDateRoute: typeof LagerauswertungWarehouseIdDateRoute
  LagerauswertungAlleDateRoute: typeof LagerauswertungAlleDateRoute
  LagerauswertungCompareDateDate2Route: typeof LagerauswertungCompareDateDate2Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/alle': {
      id: '/alle'
      path: '/alle'
      fullPath: '/alle'
      preLoaderRoute: typeof AlleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prognose/': {
      id: '/prognose/'
      path: '/prognose'
      fullPath: '/prognose'
      preLoaderRoute: typeof PrognoseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inconsistent-orders/': {
      id: '/inconsistent-orders/'
      path: '/inconsistent-orders'
      fullPath: '/inconsistent-orders'
      preLoaderRoute: typeof InconsistentOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ek-stueckliste/': {
      id: '/ek-stueckliste/'
      path: '/ek-stueckliste'
      fullPath: '/ek-stueckliste'
      preLoaderRoute: typeof EkStuecklisteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abzug-bremen/': {
      id: '/abzug-bremen/'
      path: '/abzug-bremen'
      fullPath: '/abzug-bremen'
      preLoaderRoute: typeof AbzugBremenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorschlag/$bestellvorschlagId': {
      id: '/vorschlag/$bestellvorschlagId'
      path: '/vorschlag/$bestellvorschlagId'
      fullPath: '/vorschlag/$bestellvorschlagId'
      preLoaderRoute: typeof VorschlagBestellvorschlagIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/topseller/$kundennummer': {
      id: '/topseller/$kundennummer'
      path: '/topseller/$kundennummer'
      fullPath: '/topseller/$kundennummer'
      preLoaderRoute: typeof TopsellerKundennummerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prognose/$articleNumber': {
      id: '/prognose/$articleNumber'
      path: '/prognose/$articleNumber'
      fullPath: '/prognose/$articleNumber'
      preLoaderRoute: typeof PrognoseArticleNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lagerauswertung/wicker': {
      id: '/lagerauswertung/wicker'
      path: '/lagerauswertung/wicker'
      fullPath: '/lagerauswertung/wicker'
      preLoaderRoute: typeof LagerauswertungWickerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/$kundennummer': {
      id: '/customer/$kundennummer'
      path: '/customer/$kundennummer'
      fullPath: '/customer/$kundennummer'
      preLoaderRoute: typeof CustomerKundennummerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lagerauswertung/alle/$date': {
      id: '/lagerauswertung/alle/$date'
      path: '/lagerauswertung/alle/$date'
      fullPath: '/lagerauswertung/alle/$date'
      preLoaderRoute: typeof LagerauswertungAlleDateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lagerauswertung/$warehouseId/$date': {
      id: '/lagerauswertung/$warehouseId/$date'
      path: '/lagerauswertung/$warehouseId/$date'
      fullPath: '/lagerauswertung/$warehouseId/$date'
      preLoaderRoute: typeof LagerauswertungWarehouseIdDateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lagerauswertung/compare/$date/$date2': {
      id: '/lagerauswertung/compare/$date/$date2'
      path: '/lagerauswertung/compare/$date/$date2'
      fullPath: '/lagerauswertung/compare/$date/$date2'
      preLoaderRoute: typeof LagerauswertungCompareDateDate2RouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlleRoute: AlleRoute,
  CustomerKundennummerRoute: CustomerKundennummerRoute,
  LagerauswertungWickerRoute: LagerauswertungWickerRoute,
  PrognoseArticleNumberRoute: PrognoseArticleNumberRoute,
  TopsellerKundennummerRoute: TopsellerKundennummerRoute,
  VorschlagBestellvorschlagIdRoute: VorschlagBestellvorschlagIdRoute,
  AbzugBremenIndexRoute: AbzugBremenIndexRoute,
  EkStuecklisteIndexRoute: EkStuecklisteIndexRoute,
  InconsistentOrdersIndexRoute: InconsistentOrdersIndexRoute,
  PrognoseIndexRoute: PrognoseIndexRoute,
  LagerauswertungWarehouseIdDateRoute: LagerauswertungWarehouseIdDateRoute,
  LagerauswertungAlleDateRoute: LagerauswertungAlleDateRoute,
  LagerauswertungCompareDateDate2Route: LagerauswertungCompareDateDate2Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
